<template>
  <OrderDataTable
      :loading="loading"
      :orders="orders"
      :orders-total="ordersTotalCount"
      :dialog="dialog"
      :dialog-value="dialogValue"
      @update="onUpdate"
      @excel-single="onExcelSingleDownload"
      @excel-all="onExcelAllDownload"
      @excel-all-items="onExcelAllDownloadWithItems"

      :branch-default-value="defaultValue.branch"
      :is-executor-approved-default-value="defaultValue.isExecutorApproved"
      :is-customer-approved-default-value="defaultValue.isCustomerApproved"
      :start-default-value="defaultValue.startCreatedOn"
      :end-default-value="defaultValue.endCreatedOn"
      :is-declined-default-value="defaultValue.isDeclined"
      :is-stopped-default-value="defaultValue.isStopped"
      :search-default-value="defaultValue.search"
      :page-default-value="defaultValue.page"
      :limit-default-value="defaultValue.limit"
      :sort-default-value="defaultValue.sort"
      :desc-default-value="defaultValue.desc"
      :status-default-value="defaultValue.status"
  >
    <template v-slot:title>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>Заказы</v-toolbar-title>
        <v-spacer/>
      </v-toolbar>
    </template>
  </OrderDataTable>
</template>

<script>
import OrderDataTable from "@/components/DataTables/OrderDataTable";
import OrderBoxMixin from './OrderBoxMixin'

export default {
  name: "OrderAllBoxView",
  mixins: [OrderBoxMixin],
  components: {
    OrderDataTable
  }
}
</script>